module.exports = __webpack_public_path__ + "img/level.9d535406.svg";